var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPentagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "70.25179856115108 20.645999999999997 174.5 223.758",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5985_44368)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_5985_44368)",
    d: "M243.366 34.2405C243.366 27.4802 237.886 22 231.126 22H84.2404C77.4802 22 71.9999 27.4802 71.9999 34.2404V186.007C71.9999 190.284 74.2321 194.251 77.8879 196.47L151.33 241.06C155.234 243.43 160.132 243.43 164.035 241.06L237.478 196.47C241.134 194.251 243.366 190.284 243.366 186.007V34.2405Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 3.06011,
    stroke: "url(#paint1_linear_5985_44368)",
    d: "M231.126 23.5303H84.24C78.325 23.5305 73.5301 28.3253 73.53 34.2402V186.007C73.53 189.749 75.4836 193.22 78.6824 195.162L152.125 239.752C155.54 241.826 159.825 241.826 163.241 239.752L236.684 195.162C239.883 193.22 241.836 189.749 241.836 186.007V34.2402C241.836 28.3252 237.041 23.5304 231.126 23.5303Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.16,
    fill: "#00013A",
    d: "M74.197 32.9853C74.197 28.1318 78.1315 24.1973 82.985 24.1973H232.381C237.235 24.1973 241.169 28.1318 241.169 32.9853V83.5163H74.197V32.9853Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 358.542,
    width: 309.071,
    y: -34.612,
    x: 0.0874674,
    id: "filter0_d_5985_44368"
  }, /*#__PURE__*/React.createElement("feFlood", {
    result: "BackgroundImageFix",
    floodOpacity: 0
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    type: "matrix",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.2404,
    dx: -3.06011
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.4262
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in2: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0",
    type: "matrix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "effect1_dropShadow_5985_44368",
    in2: "BackgroundImageFix",
    mode: "normal"
  }), /*#__PURE__*/React.createElement("feBlend", {
    result: "shape",
    in2: "effect1_dropShadow_5985_44368",
    in: "SourceGraphic",
    mode: "normal"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 22,
    x2: 159.925,
    y1: 244.917,
    x1: 159.925,
    id: "paint0_linear_5985_44368"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF45B4"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9100D4",
    offset: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#344AA2",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 42.8204,
    x2: 377.467,
    y1: -61.7197,
    x1: 239.565,
    id: "paint1_linear_5985_44368"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0,
    stopColor: "#ED33C1"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B617FF",
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPentagon);
export default __webpack_public_path__ + "static/media/pentagon.c8c55ccf83a2925f9a3df1c4191228eb.svg";
export { ForwardRef as ReactComponent };